/**
 * Created by Dell on 05-02-2020.
 */
import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';

class InvalidAccessOrLogin extends Component {

    render() {
        return (
            <div>
                {
                    (0 === this.props.jwtToken.length && window.location.href.indexOf("resetPassword") <= 0 ) ? (
                            <Redirect to='/login'/>) : null
                }
                {
                    (this.props.redirectToErrorPage && window.location.href.indexOf("resetPassword") <= 0 ) ? (
                            <Redirect to='/401'/>) : null
                }
                {
                    (this.props.redirectToNotFoundPage && window.location.href.indexOf("resetPassword") <= 0 ) ? (
                        <Redirect to='/404'/>) : null
                }
                {
                    (this.props.redirectToForbiddenPage && window.location.href.indexOf("resetPassword") <= 0 ) ? (
                        <Redirect to='/403'/>) : null
                }
            </div>
        )
    }
}
export default InvalidAccessOrLogin;


// WEBPACK FOOTER //
// ./src/components/errorsPage/InvalidAccessOrLogin.js